let css = require('./order-options.css');
const { FilteredSelect, Text, Select, Radio } = require('account-ui');
const signals = require('../../../../../signals/account/orders');
const { inputText, blurText } = require('../../../../../signals/form');
let CreateUser = require('./create-user');
let { redirect } = require('../../../../../signals/utils');
const { PATHS } = require('../../../../../actions/computed/account/orders');
let { cut } = require('../../../../../helpers/utils');

class OrdersOptions {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => {
            data.managerName = data.managerName || 'Не назначен';

            return Object.assign({}, data, { css });
        });
    }

    bind () {
        return {
            click: {
                [cut(css.redirect)]: this.redirect
            }
        };
    }

    redirect (e) {
        e.stopPropagation();
        let url = e.currentTarget.getAttribute('cat-url');
        this.$context.signal(redirect, { url: url });
    }
}

module.exports = {
    constructor: OrdersOptions,
    children: [
        {
            name: 'user-filtered-select',
            component: FilteredSelect,
            props: {
                signalInputText: inputText,
                signalBlurText: blurText,
                signalOnSelect: signals.selectUser,
                signalOnToggle: signals.togglePopup,
                filterPlaceholder: 'Отфильтровать...'
            },
            watcher: {
                options: PATHS.optionsFiltered,
                isDisable: ['account', 'orders', 'computed', 'selectedUser', 'isDisable'],
                isOpen: ['account', 'popups', 'userSelect', 'isOpen'],
                header: ['account', 'orders', 'computed', 'selectedUser', 'header'],
                filterValue: PATHS.usersListFilter
            }
        },
        {
            name: 'user-search',
            component: CreateUser,
            watcher: {
                showCreateError: ['account', 'orders', 'createUser', 'error', 'createError'],
                error: ['account', 'orders', 'createUser', 'error', 'email'],
                isEnabled: ['account', 'orders', 'computed', 'createUserIsEnabled']
            }
        },
        {
            name: 'manager-select',
            component: Select,
            props: {
                signalOnSelect: signals.selectManager,
                signalOnToggle: signals.togglePopup
            },
            watcher: {
                options: ['account', 'orders', 'computed', 'selectedManager', 'options'],
                isDisable: ['account', 'orders', 'computed', 'selectedManager', 'isDisable'],
                isOpen: ['account', 'popups', 'managerSelect', 'isOpen'],
                header: ['account', 'orders', 'computed', 'selectedManager', 'header']
            }
        },
        {
            name: 'radio-invoice',
            component: Radio,
            props: {
                signal: signals.selectPaymentType
            },
            watcher: {
                value: ['account', 'orders', 'computed', 'paymentType', 'invoice']
            }
        },
        {
            name: 'radio-online',
            component: Radio,
            props: {
                signal: signals.selectPaymentType
            },
            watcher: {
                value: ['account', 'orders', 'computed', 'paymentType', 'online']
            }
        },
        {
            name: 'name',
            component: Text,
            props: {
                signals: { inputText: signals.nameInputText, blurText: [] },
                position: 'leftToRight'
            },
            watcher: {
                value: ['account', 'orders', 'currentOrder', 'name'],
                error: ['account', 'orders', 'currentOrder', 'error', 'name']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/orders-options/index.js